const FEATURES = [
  {
    icon: 'ri-4k-line',
    title: '高清至4K蓝光画质',
    description: '从高清到超清、4K、蓝光，多档画质自由切换。经典老片经专业修复，画质焕然一新，满足不同设备与网速的观影需求。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '多线路播放不缓冲',
    description: '采用多线路智能分流与CDN加速技术，自动匹配最优播放节点，告别卡顿与缓冲等待，全网观影流畅稳定。',
  },
  {
    icon: 'ri-stack-line',
    title: '海量资源每日更新',
    description: '覆盖电影、电视剧、综艺、动漫、纪录片五大品类，超3万部影视资源，编辑团队每日精选更新，好片不断档。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">平台特色</h2>
            <p className="mt-2 text-sm text-foreground-500">为什么8090后选择90影院？三大核心优势告诉你</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
            {FEATURES.map((feat, i) => (
              <div
                key={i}
                className="group p-6 md:p-8 rounded-xl bg-background-50 border border-background-200/60 text-center hover:border-primary-300/40 transition-all duration-300"
              >
                <div className="w-14 h-14 mx-auto rounded-2xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors">
                  <i className={`${feat.icon} text-2xl text-primary-600`}></i>
                </div>
                <h3 className="mt-5 font-heading text-base font-semibold text-foreground-900">{feat.title}</h3>
                <p className="mt-3 text-sm text-foreground-500 leading-relaxed">{feat.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}